import React, { useMemo, useState } from 'react';
import DraggableWindow from './DraggableWindow';
import { protocoloOnlineService } from '../../services/api';

const WindowRecebeProtocolo = ({ onClose, onMinimize, isMinimized, zIndex, onFocus, userData }) => {
  const defaultCdfil = userData?.loja_id ?? userData?.cdfil ?? '';
  const defaultCdfun = userData?.matricula ?? userData?.cdfun ?? userData?.CDFUN ?? '';

  const [protocoloId, setProtocoloId] = useState('');
  const [cdfil, setCdfil] = useState(String(defaultCdfil || ''));
  const [cdfun, setCdfun] = useState(String(defaultCdfun || ''));

  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [okMsg, setOkMsg] = useState('');
  const [raw, setRaw] = useState(null);

  const canSubmit = useMemo(() => {
    return String(protocoloId).trim() && String(cdfil).trim() && String(cdfun).trim() && !loading;
  }, [protocoloId, cdfil, cdfun, loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setOkMsg('');
    setRaw(null);

    const id = String(protocoloId).trim();
    if (!id) {
      setErro('Informe o número do protocolo.');
      return;
    }

    setLoading(true);
    try {
      const resp = await protocoloOnlineService.finish({
        protocoloId: id,
        cdfil: String(cdfil).trim(),
        cdfun: String(cdfun).trim()
      });

      setOkMsg(`Protocolo ${id} finalizado/recebido com sucesso.`);
      setRaw(resp?.data ?? resp);
      setProtocoloId('');
    } catch (err) {
      console.error('Erro ao finalizar protocolo:', err);
      setErro(err?.message || 'Erro ao finalizar protocolo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DraggableWindow
      title="Receber Protocolo"
      icon="fa-clipboard-check"
      onClose={onClose}
      onMinimize={onMinimize}
      isMinimized={isMinimized}
      zIndex={zIndex}
      onFocus={onFocus}
      initialWidth={760}
      initialTop={90}
      initialLeft={420}
    >
      <form onSubmit={handleSubmit} className="consulta-form">
        <div className="consulta-form-group">
          <label>Número do Protocolo</label>
          <input
            type="text"
            value={protocoloId}
            onChange={(e) => setProtocoloId(e.target.value)}
            placeholder="Ex: 410429"
            autoComplete="off"
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>CDFIL (Loja)</label>
            <input
              type="text"
              value={cdfil}
              onChange={(e) => setCdfil(e.target.value)}
              placeholder="Ex: 22"
              autoComplete="off"
            />
          </div>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>CDFUN (Matrícula)</label>
            <input
              type="text"
              value={cdfun}
              onChange={(e) => setCdfun(e.target.value)}
              placeholder="Ex: 3794"
              autoComplete="off"
            />
          </div>
        </div>

        <button type="submit" className="consulta-btn-submit" disabled={!canSubmit} style={{ marginTop: 12 }}>
          <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-check'}`}></i>
          {loading ? 'Enviando...' : 'Receber / Finalizar'}
        </button>
      </form>

      {erro && (
        <div className="consulta-error" style={{ marginTop: 12 }}>
          <strong><i className="fas fa-exclamation-triangle"></i> {erro}</strong>
        </div>
      )}

      {okMsg && (
        <div style={{ marginTop: 12, background: '#ecfdf5', border: '1px solid #a7f3d0', color: '#065f46', padding: 12, borderRadius: 10, fontWeight: 700 }}>
          <i className="fas fa-check-circle"></i> {okMsg}
        </div>
      )}

      {raw && (
        <details style={{ marginTop: 12 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, color: '#374151' }}>Resposta bruta</summary>
          <pre style={{ marginTop: 8, background: '#111827', color: '#f8fafc', padding: 12, borderRadius: 10, fontSize: 12, overflow: 'auto' }}>
            {JSON.stringify(raw, null, 2)}
          </pre>
        </details>
      )}

      <div style={{ marginTop: 12, fontSize: 12, color: '#6b7280' }}>
        Dica: CDFIL usa a loja do usuário logado; CDFUN é a matrícula. A assinatura X-Request-Sign é gerada no proxy.
      </div>
    </DraggableWindow>
  );
};

export default WindowRecebeProtocolo;
